export const DEFAULT_RADIUS_MILES = 5;
export const MIN_RADIUS_MILES = 1;
export const MAX_RADIUS_MILES = 50;
export const METERS_PER_MILE = 1609.34;

export const DEFAULT_MAP_CENTER = { lat: 39.8283, lng: -98.5795 };
export const DEFAULT_MAP_ZOOM = 4;
export const SELECTED_LOCATION_FALLBACK = 'Selected location';

export const MAP_CIRCLE_OPTIONS = {
    strokeColor: '#5B8A72',
    strokeOpacity: 0.9,
    strokeWeight: 2,
    fillColor: '#92B4A7',
    fillOpacity: 0.28,
    clickable: false,
    draggable: false,
    editable: false
} as const;

export const milesToMeters = (miles: number): number => miles * METERS_PER_MILE;

const PRECISE_GEOCODE_TYPES = ['street_address', 'premise', 'subpremise', 'route', 'intersection'];

export const pickGeocodeAddress = (results?: Array<google.maps.GeocoderResult> | null): string | undefined => {
    if (!results?.length) return undefined;

    const locality = results.find(result => !result.types.some(type => PRECISE_GEOCODE_TYPES.includes(type)));

    return (locality ?? results[0]).formatted_address || undefined;
};
